"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@chakra-ui/react");
exports.Checkbox = react_2.forwardRef(function Checkbox(_a, ref) {
    var { boxPosition = "middle", children, error } = _a, rest = __rest(_a, ["boxPosition", "children", "error"]);
    const alignItems = react_1.useMemo(() => {
        switch (boxPosition) {
            case "middle":
                return "center";
            case "top":
                return "flex-start";
            case "bottom":
                return "flex-end";
        }
    }, [boxPosition]);
    return (react_1.default.createElement(react_2.Checkbox, Object.assign({ alignItems: alignItems, colorScheme: "primary", color: "darkgray.700", textStyle: "body1", ref: ref, lineHeight: "inherit", sx: {
            ".chakra-checkbox__control": {
                backgroundColor: "white",
                borderColor: error ? "danger.600" : "lightgray.600",
                borderWidth: "1px",
                height: "20px",
                width: "20px",
                "&:hover": {
                    borderColor: error ? "danger.600" : "darkgray.100",
                },
                "&[data-checked]": {
                    backgroundColor: "primary.500",
                },
                "&[data-focus]": {
                    borderColor: "primary.500",
                },
                "&[data-disabled]": {
                    bg: "lightgray.300",
                    borderColor: "lightgray.600",
                    borderStyle: "solid",
                    borderWidth: "1px",
                },
            },
            ".chakra-checkbox__label": {
                marginLeft: "12px",
                fontSize: "sm",
            },
        } }, rest), children));
});
//# sourceMappingURL=Checkbox.js.map